import { useMutation, useQuery } from '@ywwwtseng/react-kit';
import { Typography } from '@ywwwtseng/tma-react-kit';
import * as schema from '@/db/schema';
import dayjs from '../../lib/dayjs';
import { Switch } from '../../components/ui/Switch';
import { List } from '../../components/common/List';
import { ChatPhoto } from '../../components/common/ChatPhoto';

export default function GroupChannelScreenSettings() {
  const { mutate } = useMutation('chat:update');
  const { data } =
    useQuery<(typeof schema.tg_chats.$inferSelect)[]>('manageable_chats', {
      showLoading: true,
    });

  if (!data) return null;

  return (
    <div className="flex flex-col items-center justify-start w-full h-full gap-5 py-3 px-5">
      <List
        title={
          <Typography size="1" weight={600} i18n="add_chat.allow_guest_gifts" />
        }
        className="flex flex-col w-full gap-2"
        data={data}
      >
        {(chat) => {
          return (
            <div
              key={chat.id}
              className="card h-stack w-full gap-2 px-3 py-2 cursor-pointer"
            // onClick={() => {
            //   openTelegramLink(`https://t.me/${chat.username}`);
            // }}
            >
              <ChatPhoto chat={chat} />
              <div className="h-stack w-full">
                <div className="v-stack w-full !items-start">
                  <Typography size="3" weight={500}>
                    {chat.name}
                  </Typography>
                  <Typography size="1" color="#777777">
                    {dayjs(chat.created_at).format('YYYY/MM/DD HH:mm')}
                  </Typography>
                </div>
                <Switch
                  checked={chat.allow_guest_gifts ?? false}
                  onChange={(checked) => {
                    void mutate(
                      { chat_id: chat.id, allow_guest_gifts: checked },
                    );
                  }}
                />
              </div>
            </div>
          );
        }}
      </List>
    </div>
  );
}
